import React from 'react';
import { motion } from 'framer-motion';

const directors = [
  {
    name: 'Mr. Massoodh Ahmed',
    title: 'Chairman',
    description:
      'Mr. Massoodh Ahmed is the Chairman of MASRIQ NextTech Solutions, renowned for his strategic leadership, business management, and commitment to technological excellence. With decades of expertise in corporate innovation, he shapes MASRIQ’s AI, SaaS, and software development vision to drive global growth.',
    img: '/team/Massoodh_img.webp',
    alt: 'Chairman of MASRIQ NextTech Solutions - Mr. Massoodh Ahmed, AI and business strategy leader',
  },
  {
    name: 'Mr. Sawood Ahmed',
    title: 'Founder & CEO',
    description:
      'Mr. Sawood Ahmed, Founder & CEO of MASRIQ NextTech Solutions, is a visionary entrepreneur and AI specialist. His expertise in artificial intelligence, SaaS platforms, and digital transformation empowers MASRIQ to deliver next-generation software solutions for enterprises and startups worldwide.',
    img: '/team/Sawood_img.webp',
    alt: 'Founder & CEO of MASRIQ NextTech Solutions - Mr. Sawood Ahmed, AI and SaaS innovation expert',
  },
  {
    name: 'Mr. Roshan Zameer',
    title: 'Sleeping Partner',
    description:
      'Mr. Roshan Zameer is a strategic partner at MASRIQ NextTech Solutions, contributing his expertise in software architecture and scalable system design. His insights strengthen MASRIQ’s technical foundation and support the company’s mission of AI-driven innovation.',
    img: '/team/Roshan_img.webp',
    alt: 'Sleeping Partner of MASRIQ NextTech Solutions - Mr. Roshan Zameer, software architecture strategist',
  },
  {
    name: 'Mr. Mohammed Iqlaas',
    title: 'Chief Operating Officer (COO)',
    description:
      'Mr. Mohammed Iqlaas leads MASRIQ’s day-to-day operations and delivery excellence as COO. He scales processes, optimizes cross-functional workflows, and ensures projects ship on time with quality, security, and compliance. His leadership aligns product, engineering, and customer success to turn strategy into repeatable outcomes.',
    img: '/team/Iqlaas_img.webp',
    alt: 'Chief Operating Officer of MASRIQ NextTech Solutions - Mr. Mohammed Iqlaas, operations and delivery leadership',
  },
  {
    name: 'Ms. Riya Tanwar',
    title: 'Chief Administrative Officer (CAO)',
    description:
      'Ms. Riya Tanwar oversees corporate governance, HR, finance operations, and policy administration as CAO. She builds high-performance culture, streamlines internal systems, and enables teams with clear processes and compliant practices, ensuring MASRIQ operates efficiently and responsibly at scale.',
    img: '/team/Riya_img.webp',
    alt: 'Chief Administrative Officer of MASRIQ NextTech Solutions - Ms. Riya Tanwar, governance and administrative leadership',
  },
];

const Directors = () => {
  return (
    <section
      id="directors"
      className="py-24 px-6 bg-gradient-to-b from-[#0f0c29] via-[#302b63] to-[#24243e] text-white"
    >
      <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-neon to-highlight bg-clip-text text-transparent">
        Our Directors
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto">
        {directors.map((director, index) => (
          <motion.article
            key={index}
            className="bg-glass backdrop-blur-md p-8 rounded-2xl shadow-glow flex flex-col items-center text-center hover:scale-105 transition duration-300"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.3 }}
            viewport={{ once: true }}
          >
            <img
              src={director.img}
              alt={director.alt}
              className="w-28 h-28 rounded-full object-cover border-4 border-neon mb-4"
              loading="lazy"
            />
            <h3 className="text-2xl font-semibold">{director.name}</h3>
            <p className="text-sm text-highlight">{director.title}</p>
            <p className="text-white/80 mt-3 text-sm">{director.description}</p>
          </motion.article>
        ))}
      </div>

      {/* SEO Schema Markup for Directors */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "MASRIQ NextTech Solutions",
          url: "https://www.masriq.tech",
          sameAs: [
            "https://linkedin.com/company/masriq",
            "https://github.com/masriq",
          ],
          employee: directors.map((d) => ({
            "@type": "Person",
            name: d.name,
            jobTitle: d.title,
            description: d.description,
            image: `https://www.masriq.tech${d.img}`,
            worksFor: {
              "@type": "Organization",
              name: "MASRIQ NextTech Solutions",
            },
          })),
        })}
      </script>
    </section>
  );
};

export default Directors;
